var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    {
      staticClass: "grid grid-cols-1 gap-4 add-internal-comment-to-loans-modal",
    },
    [
      _c("div", { staticClass: "w-full pt-2 flex-col" }, [
        _c(
          "div",
          { staticClass: "w-full" },
          [
            _c(
              "field",
              { staticClass: "mb-2", attrs: { label: "Comment" } },
              [
                _c("textarea-field", {
                  model: {
                    value: _vm.comment,
                    callback: function ($$v) {
                      _vm.comment = $$v
                    },
                    expression: "comment",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-row-reverse pt-4" },
          [
            _c(
              "btn",
              {
                on: {
                  click: function ($event) {
                    return _vm.addCommentToLoans()
                  },
                },
              },
              [_vm._v("Add")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }